var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAuto = function SvgAuto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.382 5.28c7.777 0 14.083 6.306 14.083 14.085 0 7.779-6.306 14.085-14.083 14.085C6.6 33.453.295 27.143.295 19.365.295 11.587 6.6 5.28 14.382 5.28Z",
    fill: "#E0F2FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.53 15.568a4.19 4.19 0 0 0-2.066-.06 4.16 4.16 0 0 0-1.838.933 4.093 4.093 0 0 0-1.153 1.695.64.64 0 0 1-.814.384.628.628 0 0 1-.388-.804 5.352 5.352 0 0 1 1.508-2.217 5.44 5.44 0 0 1 2.404-1.22 5.479 5.479 0 0 1 2.7.079c.877.25 1.675.715 2.32 1.351l1.384 1.285v-1.693c0-.348.285-.63.637-.63.352 0 .638.282.638.63v3.15c0 .348-.286.63-.638.63h-3.187a.634.634 0 0 1-.637-.63c0-.348.285-.63.637-.63h1.578l-1.292-1.2-.014-.014a4.153 4.153 0 0 0-1.78-1.039ZM7.9 20.551c0-.348.286-.63.638-.63h3.187c.352 0 .637.282.637.63 0 .348-.285.63-.637.63h-1.578l1.292 1.2.014.014a4.19 4.19 0 0 0 3.845 1.1 4.16 4.16 0 0 0 1.838-.934c.523-.46.92-1.043 1.153-1.695a.64.64 0 0 1 .814-.384.628.628 0 0 1 .388.804 5.352 5.352 0 0 1-1.508 2.216 5.44 5.44 0 0 1-2.404 1.22c-.893.2-1.822.173-2.701-.078a5.432 5.432 0 0 1-2.32-1.351l-1.383-1.286v1.694c0 .348-.285.63-.637.63a.634.634 0 0 1-.638-.63v-3.15Z",
    fill: "#0086C9"
  })));
};

export default SvgAuto;